<template>
<div class="wrap">
    <h4>Наличие на удаленном складе по бренду {{brand.brand}}</h4>
    <app-alert v-if="load_ost"></app-alert>

    <div class="invask">
        <div v-if="!load_ost" class="fortbl">
            <div class="forselect">
                <label>Категория</label>
                <b-form-select v-model="selCat" :options="arrCat" v-if="arrCat.length > 0" />
                <p v-if="!selCat && arrCat.length > 0">Выберите категорию</p>
            </div>

            <my-tab :items="arrCatSel" class="mt-3  table-hover table-responsive" v-if="arrCatSel.length > 0 && selCat"></my-tab>
            <h3 v-if="arrCat.length == 0">Нет данных для отображения</h3>
        </div>

    </div>

    <b-btn class="cloze mb-4" variant="outline-primary" block @click="close()">Назад к выбору бренда</b-btn>
</div>
</template>

<script>
import Vue from 'vue'

import AppAlert from "../components/AppAlert.vue"
import MyTab from "../components/MyTab1.vue"
import AppModal from "../components/AppModal.vue"

export default {
    props: ['brand'],
    data() {
        return {
            load_ost: false,
            selCat: '',
            ost: []

        }
    },
    mounted() {
        this.Ost()
    },
    computed: {

        arrCat() {
            let arr = []
            this.ost.forEach((item) => {
                if (arr.indexOf(item['catName']) == -1) {
                    arr.push(item['catName'])
                }
            })
            return arr

        },
        arrCatSel() {
            let arr = []
            this.ost.forEach((item) => {
                if (item['catName'] == this.selCat) {
                    arr.push(item)
                }
            })
            return arr

        }
    },
    methods: {
        Ost() {
            this.load_ost = true
            this.selCat = ''
            Vue.http.get('invask.php', {
                    params: {
                        brand: this.brand.brand,
                        post: this.brand.post
                    }
                })
                .then(response => {

                    this.ost = response.data
                    this.load_ost = false
                  

                })
        },
        close() {
            this.$store.commit('all/clearBrand', {
                'brand': '',
                'post': '',
                'card': true
            })

        }
    },
    components: {
        AppModal,
        MyTab,
        AppAlert
    }
}
</script>

<style scoped>
.wrap {
    width: 100%;
}

h4 {
    text-align: center;
    width: 100%;
}

.invask {
    width: 100%;
}

.fortbl {
    width: 90%;
    margin: 0 auto;
}
.forselect{
    border-radius: 5px;
    position: sticky;
    top: 5px;
    background-color: #847d9b;
    color: #fff;
    padding: 5px;
    z-index: 10;
}

.cloze {
    width: 90%;
    margin: 0 auto;
}
</style>
